import { render, staticRenderFns } from "./common-middle-header.vue?vue&type=template&id=21401f76&scoped=true&lang=pug&"
import script from "./common-middle-header.vue?vue&type=script&lang=js&"
export * from "./common-middle-header.vue?vue&type=script&lang=js&"
import style0 from "./common-middle-header.vue?vue&type=style&index=0&id=21401f76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21401f76",
  null
  
)

export default component.exports